module.exports = __webpack_public_path__ + "f8122eb7efbc72d862e13587a08f8909.jpg";